import React from "react";
import { Nav, NavbarContainer, NavLogo, NavIcon } from "./Navbar.elements";

const Navbar = () => {
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo>
          <NavIcon aria-hidden="true" />
          Peragal Tech
        </NavLogo>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
